export { default } from './CompetitiveSets';